import * as angular from "angular";
import {IController} from "angular";

export class locationToPlaceCtrl implements IController {
  location: any;
  public place;
  public loading: boolean;

  constructor(private latLngToAddress, private $log) {
  }


  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.location && this.location) {
      this.loading = true;
      this.latLngToAddress(this.location.latitude, this.location.longitude)
        .then((place) => {
          this.place = place;
        })
        .catch((error) => {
          this.$log.error('Failed to get address by coordinates,', error)
        })
        .finally(() => {
          this.loading = false;
        })
    } else if (!this.location) {
      this.place = undefined
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('locationToPlace', {
    bindings: {
      location: '<?',

    },
    template: require('./location-to-place.html').default,
    controller: locationToPlaceCtrl
  });
